import React from 'react';
import './InfoAbout.scss';
import WrapperLayout from 'Components/Shared/WrapperLayout/WrapperLayout';

interface IProps {
  content: Julius.Website.AboutPageViewModel;
}

const InfoAbout: React.SFC<IProps> = ({
  content,
}) => {

  if (!content) {
    return null;
  }

  const { title, text } = content;

  return (
    <WrapperLayout style='info-about'>
      <div className='about-title'>{ title }</div>
      <div dangerouslySetInnerHTML={ { __html: text } } />
    </WrapperLayout>
  );
};

export default InfoAbout;


// WEBPACK FOOTER //
// ./src/components/InfoAbout/InfoAbout.tsx